import { type Writable, writable } from "svelte/store";

export type ValueWritable<T> = Writable<T> & { readonly value: T };

export function valueWritable<T>(value?: T): ValueWritable<T> {
    const store = writable<T>(value);

    return {
        subscribe: store.subscribe,
        set(val: T) {
            value = val;
            store.set(value);
        },
        update(fn: (value: T) => T) {
            value = fn(value!);
            store.set(value);
        },
        get value() {
            return value!;
        },
    };
}
